import React from 'react';
import { Box, Grid, Hidden } from '@material-ui/core';
import { Button } from '@one-thd/sui-atomic-components';
import { pkPLCCBanner } from '../../../../constants/ProXtraPerks';
import { floorNumberWithCommas } from '../../../Utils';
import { LazyImage } from '../../../shared/LazyImage';
import { getImageURL } from '../../../../utils/GeneralUtil';
import { renderTooltip } from '../PLCCBanners';
import { clickCta } from '../../../../utils/analytics';
export var ModalCardLogo = function () { return (React.createElement(LazyImage, { src: getImageURL('PrgDetails/card.png'), classes: "PerkPLCC__cardModalLogo", altText: "Top banner, Home Depot store" })); };
export var ModalCardLogoAngled = function () { return (React.createElement(LazyImage, { src: getImageURL('PLCC/graphic-plcc-PreEnrolled-left.svg'), classes: "PerkPLCC__cardModalLogo2", altText: "Top banner, Home Depot store" })); };
var handleClick = function (props) {
    var setTogglePLCC = props.setTogglePLCC, plccSwitch = props.plccSwitch;
    if (plccSwitch) {
        setTogglePLCC(false);
    }
    else {
        clickCta('rewards hub: pro xtra credit card overlay: apply now button');
        window.open(pkPLCCBanner.applyNowPlcc, '_blank', 'noopener,noreferrer');
    }
};
export var ModalMoreBenefitsList = function (props) {
    var plccSwitch = props.plccSwitch;
    return (React.createElement(Grid, { item: true, xs: 12, className: "".concat(!plccSwitch ? 'PerkPLCC__moreBenefitsListContainer' : '') },
        React.createElement(Grid, { className: "PerkPLCC__modalUnlockNextSubLabel2" }, pkPLCCBanner.moreBenefits),
        React.createElement("ul", { className: "PerkPLCC__modalMoreBenfitList" }, pkPLCCBanner.BenefitsListState.map(function (localState, index) { return (React.createElement("li", { key: index }, localState.BenefitsList)); }))));
};
export var ModalQualifyingSpendLabel = function (props) {
    var activePxccFactor = props.activePxccFactor;
    return (React.createElement(Grid, { item: true },
        React.createElement(Grid, { item: true, className: "PerkPLCC__modalAccelerateBox" },
            React.createElement(Grid, { className: "PerkPLCC__modalUnlockPerkLabelHeader sui-mb-2" }, "How To Accelerate Perk Spend"),
            React.createElement(Grid, { className: "PerkPLCC__modalUnlockPerkLabel" }, "With the Pro Xtra Credit Card, every dollar you spend at The Home Depot counts ".concat(activePxccFactor, "X towards your Perks.")))));
};
export var ModalQualifyingSpend = function (props) {
    var _a, _b, _c, _d, _e, _f;
    var accrualData = props.accrualData, activePxccFactor = props.activePxccFactor, onClick = props.onClick;
    return (React.createElement(Grid, { container: true, className: "PerkPLCC__QualifyingSpendBox", onClick: onClick },
        React.createElement(Grid, { item: true, xs: 7, className: "PerkPLCC__QualifyingGridHeader" },
            pkPLCCBanner.QualifyingSpend,
            React.createElement("span", { className: "PerkPLCC__offerExc" },
                " ",
                renderTooltip())),
        React.createElement(Grid, { item: true, xs: 2, className: "PerkPLCC__modalBonusHeader" }, pkPLCCBanner.bonus),
        React.createElement(Grid, { item: true, xs: 3, className: "PerkPLCC__QualifyingGridHeader1 rightBox" }, pkPLCCBanner.perkSpend),
        React.createElement(Grid, { container: true, className: "PerkPLCC__modalTotalDetailsBox" },
            React.createElement(Grid, { item: true, xs: 4 },
                React.createElement(Grid, { className: "label" },
                    React.createElement(Hidden, { smDown: true },
                        React.createElement(Grid, null,
                            pkPLCCBanner.plccCardL,
                            ":")),
                    React.createElement(Hidden, { mdUp: true }, pkPLCCBanner.plccCardS),
                    React.createElement(Grid, null, "Other Tenders:")),
                React.createElement(Grid, { className: "PerkPLCC__modalTotalSpend" }, "Totals")),
            React.createElement(Grid, { item: true, xs: 3 },
                React.createElement(Grid, { className: "PerkPLCC__modalAmountSpendBox" },
                    React.createElement(Grid, null,
                        "$",
                        floorNumberWithCommas((_a = accrualData === null || accrualData === void 0 ? void 0 : accrualData[0]) === null || _a === void 0 ? void 0 : _a.pxccAccrual, 0)),
                    React.createElement(Grid, null,
                        "$",
                        floorNumberWithCommas((_b = accrualData === null || accrualData === void 0 ? void 0 : accrualData[0]) === null || _b === void 0 ? void 0 : _b.nonPxccAccrual, 0))),
                React.createElement(Grid, { className: "PerkPLCC__modalTotalSpendAmount" },
                    "$",
                    floorNumberWithCommas((_c = accrualData === null || accrualData === void 0 ? void 0 : accrualData[0]) === null || _c === void 0 ? void 0 : _c.accrual, 0))),
            React.createElement(Grid, { item: true, xs: 2 },
                React.createElement(Grid, { className: "PerkPLCC__innerCircleBox label" },
                    React.createElement(Grid, null,
                        "\u00A0",
                        React.createElement("p", { className: "PerkPLCC__modalCircle" },
                            activePxccFactor,
                            "X")),
                    React.createElement(Grid, null, "\u00A0")),
                React.createElement(Grid, { className: "PerkPLCC__modalTotalSpend" }, "\u00A0")),
            React.createElement(Grid, { item: true, xs: 3, className: "rightBox" },
                React.createElement(Grid, { className: "label" },
                    React.createElement(Grid, { className: "cardAmount" },
                        "$",
                        floorNumberWithCommas((_d = accrualData === null || accrualData === void 0 ? void 0 : accrualData[0]) === null || _d === void 0 ? void 0 : _d.pxccAcceleratedAccrual, 0)),
                    React.createElement(Grid, null,
                        "$",
                        floorNumberWithCommas((_e = accrualData === null || accrualData === void 0 ? void 0 : accrualData[0]) === null || _e === void 0 ? void 0 : _e.nonPxccAccrual, 0))),
                React.createElement(Grid, { className: "PerkPLCC__modalTotalSpend" },
                    "$",
                    floorNumberWithCommas((_f = accrualData === null || accrualData === void 0 ? void 0 : accrualData[0]) === null || _f === void 0 ? void 0 : _f.acceleratedAccrual, 0)))),
        React.createElement(Grid, { className: "PerkPLCC__Sub-totals sui-pb-2" }, pkPLCCBanner.starSubTotal)));
};
export var ModalUnlockNextPerk = function (props) {
    var _a, _b;
    var accrualData = props.accrualData, activePxccFactor = props.activePxccFactor, isMobile = props.isMobile;
    return (React.createElement(Grid, { item: true },
        React.createElement(Grid, { className: "PerkPLCC__modalUnlockNextSubLabel" }, pkPLCCBanner.spendNeeded),
        React.createElement(Grid, { container: true, className: "PerkPLCC__modalProXtraSpend " },
            React.createElement(Grid, { item: true, className: "PerkPLCC__modalProXtraSpendBox" },
                React.createElement(Grid, { className: "PerkPLCC__modalProXtraSpendLine" },
                    React.createElement("span", null, " With\u00A0"),
                    React.createElement("p", { className: "PerkPLCC__drawerCircle mNPerk" },
                        activePxccFactor,
                        "X"),
                    React.createElement("span", { className: "PerkPLCC__modalCircleLabel" }, isMobile ? 'Pro Xtra Card:' : 'Pro Xtra Credit Card:'),
                    React.createElement("span", { className: "PerkPLCC__modalRightAmount" },
                        "$",
                        floorNumberWithCommas((_a = accrualData === null || accrualData === void 0 ? void 0 : accrualData[0]) === null || _a === void 0 ? void 0 : _a.spendForNextPerkWithPxcc, 0))),
                React.createElement(Grid, { className: "PerkPLCC__modalProXtraSpendBottomLine" },
                    "With Other Tenders:",
                    React.createElement("span", { className: "PerkPLCC__modalRightAmount" },
                        "$",
                        floorNumberWithCommas((_b = accrualData === null || accrualData === void 0 ? void 0 : accrualData[0]) === null || _b === void 0 ? void 0 : _b.spendForNextPerk, 0)))))));
};
export var ModalMobileCardLabel = function (props) {
    var activePxccFactor = props.activePxccFactor, hideLabel = props.hideLabel, hideCardLogo = props.hideCardLogo;
    return (React.createElement(Grid, { container: true, className: "PerkPLCC__modalAccelerateBox" },
        hideCardLogo ? null : (React.createElement(Grid, { item: true, sm: 2, xs: 3, className: "PerkPLCC__modalAccelerateCard" },
            React.createElement(Grid, { className: "PerkPLCC__modalInnerCircle" },
                activePxccFactor,
                "X"),
            React.createElement(ModalCardLogo, null))),
        !hideLabel ? (React.createElement(Grid, { item: true, className: "PerkPLCC__CreditCardEarnsLabel" },
            React.createElement(ModalCreditCardEarnsLabel, { activePxccFactor: activePxccFactor }))) : null));
};
export var ModalCreditCardEarnsLabel = function (props) {
    var activePxccFactor = props.activePxccFactor;
    return (React.createElement(Grid, null,
        pkPLCCBanner.plccAccelerateDesc1,
        " ",
        activePxccFactor,
        "X",
        ' ',
        pkPLCCBanner.plccAccelerateDesc2));
};
export var ModalTowardsPerks = function (props) {
    var activePxccFactor = props.activePxccFactor;
    return (React.createElement(Grid, { item: true, xs: 12 },
        React.createElement(Grid, { className: "PerkPLCC__modalUnlockNextLabel" },
            "Earn Perks ",
            activePxccFactor,
            "X Faster with the Pro Xtra Credit Card"),
        React.createElement(Grid, { className: "PerkPLCC__modalTowardsSubLabel" },
            React.createElement(ModalCreditCardEarnsLabel, { data: activePxccFactor }))));
};
export var ModalSubTitle = function (props) {
    var _a, _b, _c;
    return props.plccSwitch
        ? "".concat((_c = (_b = (_a = props === null || props === void 0 ? void 0 : props.perksInfo) === null || _a === void 0 ? void 0 : _a.accrualData) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.year, " Pro Xtra Perks Spend Details")
        : "Pro Xtra Credit Card";
};
export var ModalMobileSubTitle = function (props) {
    var plccSwitch = props.plccSwitch, year = props.year;
    return (React.createElement(Grid, { className: "PerkPLCC__modalMobileAHead" },
        React.createElement("span", { className: "sui-font-bold" }, plccSwitch
            ? "".concat(year, " Pro Xtra Perks Spend Details")
            : 'Sign up for the Pro Xtra Credit Card')));
};
export var ModalCloseIcon = function (props) {
    var setTogglePLCC = props.setTogglePLCC;
    return (React.createElement("button", { type: "button", className: "header-button", "aria-label": "button", onClick: function () { return setTogglePLCC(false); } },
        React.createElement(LazyImage, { src: "https://assets.thdstatic.com/images/v1/path-to-pro/close_icon_black.svg", width: "16px", height: "16px", altText: "close", classes: "bottom-sheet-header-close" })));
};
export var ModalCloseButton = function (props) {
    var plccSwitch = props.plccSwitch;
    return (React.createElement(Box, { className: "PerkPLCC__modalCloseButtonContainer" },
        React.createElement(Button, { fullWidth: true, variant: "primary", onClick: function () { return handleClick(props); } }, plccSwitch ? 'Close' : 'Apply Now')));
};
